/* src/app/components/common/menu/menu.component.scss */
/*# sourceMappingURL=menu.component.css.map */
